import type { ReactNode } from "react"

import { tv, type VariantProps } from "@/lib/utils/tv"

// The markdown sello — a rounded-full pill that rides on the packshot corner.
// `red` is the canonical sale red (matched to the sale price); `size` sm is the
// on-card sello, md the larger inline form.
const discountBadge = tv({
  base: "inline-flex items-center gap-100 rounded-full",
  variants: {
    tone: {
      brand: "bg-brand text-fg-inverted",
      red: "bg-surface-sale text-fg-inverted",
    },
    // A stadium's usable interior is narrower than its padding implies, because the
    // end radius curves into the text's space. These carry more horizontal padding
    // than a squared pill of the same size would need.
    size: {
      xs: "font-display text-body-sm font-bold px-150 py-100",
      sm: "font-text text-caption-lg leading-detail font-semibold tracking-snug px-200 py-75 @card:text-body-sm @card:leading-4.5",
      md: "font-display text-body-sm font-bold px-350 py-100",
      // The PDP price row's badge, set in the price row's text face.
      little: "font-text text-little @3xl:text-little-lg px-200 py-px",
    },
  },
  defaultVariants: { tone: "brand", size: "md" },
})

interface DiscountBadgeProps extends VariantProps<typeof discountBadge> {
  className?: string
  children: ReactNode
}

export const DiscountBadge = ({ tone, size, className, children }: DiscountBadgeProps) => <span className={discountBadge({ tone, size, className })}>{children}</span>
